import { Injectable } from '@angular/core';
import gql from 'graphql-tag';
import { GraphQLClient } from '../shared/services/graph-qlclient.service';

@Injectable({
  providedIn: 'root',
})
export class MixturaService {
  constructor(private gqlclient: GraphQLClient) {}

  AgregarMixtura(inputParams, callback: Function) {
    this.gqlclient.query(
      {
        query: gql`
          mutation ($entidad: mixturaInputType) {
            mixtura {
              agregar(entidad: $entidad) {
                respuesta {
                  codigo
                  nombre
                  activado
                }
              }
            }
          }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.mixtura.agregar;
        callback({ mensajes, respuesta });
      }
    );
  }

  EditarMixtura(inputParams, callback: Function) {
    this.gqlclient.query(
      {
        query: gql`
          mutation ($entidad: mixturaInputType) {
            mixtura {
              modificar(entidad: $entidad) {
                respuesta {
                  codigo
                  nombre
                  activado
                }
              }
            }
          }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.mixtura.modificar;
        callback({ mensajes, respuesta });
      }
    );
  }

  obtenerSegunFiltro(inputParams, callback: Function) {
    this.gqlclient.query(
      {
        query: gql`
          query ($entidad: mixturaInputType) {
            mixtura {
              obtenerSegunFiltro(filtro: { exacto: $entidad }) {
                respuesta {
                  registros {
                    codigo
                    nombre
                    activado
                  }
                }
              }
            }
          }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.mixtura.obtenerSegunFiltro;
        callback({ mensajes, respuesta });
      }
    );
  }

  obtenerTodos(callback: Function) {
    this.gqlclient.query(
      {
        query: gql`
          query {
            mixtura {
              obtenerTodos {
                respuesta {
                  registros {
                    codigo
                    activado
                    nombre
                  }
                }
              }
            }
          }
        `,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.mixtura.obtenerTodos;
        callback({ mensajes, respuesta });
      }
    );
  }
}
